// Port of api/fuel/app/classes/controller/api/monty/users/tools.php
// Port of api/fuel/app/classes/controller/api/monty/traits/tools.php
// Port of api/fuel/app/classes/controller/api/monty/traits/tools/heatmap.php
// Port of api/fuel/app/classes/controller/api/monty/traits/tools/playgrid.php
// Port of api/fuel/app/classes/controller/api/monty/traits/tools/wordcloud.php
import Constants from 'offline/constants'
import Util from 'offline/util'
import { resolveOwner } from 'offline/api/monty'
import F from 'offline/filter/constants'
import PlaysFilter from 'offline/filter/plays'
import Category from 'offline/model/category'
import Collection from 'offline/model/collection'
import GameCategory from 'offline/model/game/category'
import Play from 'offline/model/play'
import Rating from 'offline/model/rating'

function toolPlaygrid(owner, filter) {
	var searchFilter = {
		source: {
			plays: true
		},
		play: {
			group: filter.group,
			first: filter.first
		},
		played: {
			period: filter.period,
			range: {
				from: filter.date.from,
				to: filter.date.to
			}
		},
		expansions: filter.expansions,
		sort: filter.sort,
		sortReverse: filter.sortReverse
	}

	var size = filter.layout.grid * filter.layout.grid

	return PlaysFilter.forge({
		owner: owner,
		cache: false,
		filter: searchFilter,
		page: 1,
		perpage: size,
		knownUsers: []
	}).run().to_array()
}

function applicablePlayIndex(owner, filter) {
	var searchFilter = {
		source: {
			plays: true
		},
		play: {
			count: {
				from: filter.count.from,
				to: filter.count.to
			},
			duration: {
				from: filter.duration.from,
				to: filter.duration.to
			},
			locations: filter.locations,
			players: {
				required: filter.players.required,
				together: filter.players.together
			}
		},
		games: {
			subset: filter.games
		},
		played: {
			range: {
				from: filter.date.from,
				to: filter.date.to
			}
		}
	}

	return PlaysFilter.forge({
		owner: owner,
		cache: false,
		filter: searchFilter,
		page: 1,
		knownUsers: [],
		asIndex: true
	}).run()
}

function toolHeatmap(owner, userIndex, filter) {
	var applicableIndex = applicablePlayIndex(owner, filter)
	var data = {}
	var plays = {}
	var total = 0
	var firstPlay = 0
	var lastPlay = 0

	if (applicableIndex.length) {
		var range = {
			from: Util.date_start(filter.date.from),
			to: Util.date_end(filter.date.to)
		}

		if (filter.type === 'plays') {
			var dates = Play.filter({
				arrayed: true,
				select: {
					plain: ['play_date'],
					sum: { play_count: 'play_count' }
				},
				where: [
					['play_id', 'in', applicableIndex]
				],
				group: ['play_date']
			})

			for (var i = 0; i < dates.length; i++) {
				var item = dates[i]
				if (item.play_date < firstPlay || firstPlay === 0) firstPlay = item.play_date
				if (item.play_date > lastPlay) lastPlay = item.play_date
				if (!plays[item.play_date]) plays[item.play_date] = { count: 0 }
				plays[item.play_date].count += item.play_count
				total += item.play_count
			}
		} else if (filter.type === 'weight') {
			var weightedDates = Util.query(
				'SELECT p.play_date AS date, SUM(p.play_count) AS count, SUM(g.game_weight_avg * p.play_count) AS weight FROM play p JOIN game g ON p.game_id = g.game_id WHERE p.play_id IN (' + Util.in(applicableIndex) + ') GROUP BY p.play_date'
			)

			for (var j = 0; j < weightedDates.length; j++) {
				var weighted = weightedDates[j]
				if (weighted.date < firstPlay || firstPlay === 0) firstPlay = weighted.date
				if (weighted.date > lastPlay) lastPlay = weighted.date
				if (!plays[weighted.date]) plays[weighted.date] = { count: 0, totalWeight: 0, weight: 0 }
				plays[weighted.date].totalWeight += parseFloat(weighted.weight || 0)
				plays[weighted.date].count += parseInt(weighted.count || 0, 10)
				plays[weighted.date].weight = plays[weighted.date].count ? plays[weighted.date].totalWeight / plays[weighted.date].count : 0
				total += parseInt(weighted.count || 0, 10)
			}
		} else if (filter.type === 'wins') {
			var winDates = Util.query(
				'SELECT p.play_date AS date, SUM(p.play_count) AS count, SUM(p.play_won) AS wins FROM play p WHERE p.play_id IN (' + Util.in(applicableIndex) + ') GROUP BY p.play_date'
			)

			for (var k = 0; k < winDates.length; k++) {
				var won = winDates[k]
				if (won.date < firstPlay || firstPlay === 0) firstPlay = won.date
				if (won.date > lastPlay) lastPlay = won.date
				if (!plays[won.date]) plays[won.date] = { count: 0, wins: 0 }
				plays[won.date].wins += parseInt(won.wins || 0, 10)
				plays[won.date].count += parseInt(won.count || 0, 10)
			}
		} else if (filter.type === 'new') {
			var earliestPlays = Play.filter({
				arrayed: true,
				select: {
					plain: ['game_id'],
					min: { play_date: 'play_date' }
				},
				where: [
					['play_id', 'in', applicableIndex]
				],
				group: ['game_id']
			})

			var playsBefore = Play.filter({
				indexed: 'game_id',
				where: [
					['user_id', 'in', userIndex],
					['play_date', '<', range.from]
				],
				group: ['game_id']
			})

			for (var l = 0; l < earliestPlays.length; l++) {
				var earliest = earliestPlays[l]
				if (earliest.play_date < firstPlay || firstPlay === 0) firstPlay = earliest.play_date
				if (earliest.play_date > lastPlay) lastPlay = earliest.play_date

				if (!playsBefore[earliest.game_id]) {
					if (!plays[earliest.play_date]) plays[earliest.play_date] = { count: 0 }
					plays[earliest.play_date].count++
					total++
				}
			}
		}
	}

	return {
		firstPlay: firstPlay,
		lastPlay: lastPlay,
		total: total,
		plays: plays,
		data: data
	}
}

function toolWordcloud(userIndex, filter) {
	var words = []
	var rawGames = []

	if (filter.type === 'collection') {
		rawGames = Collection.filter({
			arrayed: true,
			select: {
				plain: ['game_id']
			},
			where: [
				['user_id', 'in', userIndex]
			]
		})
	} else if (filter.type === 'ratings') {
		rawGames = Rating.filter({
			arrayed: true,
			select: {
				plain: ['game_id', 'rating_value']
			},
			where: [
				['user_id', 'in', userIndex]
			]
		})
	} else if (filter.type === 'plays') {
		var where = [
			['user_id', 'in', userIndex]
		]

		if (filter.date.from) where.push(['play_date', '>=', filter.date.from])
		if (filter.date.to) where.push(['play_date', '<', filter.date.to])

		rawGames = Play.filter({
			arrayed: true,
			select: {
				plain: ['game_id'],
				sum: { play_count: 'play_count' }
			},
			where: where,
			group: ['game_id']
		})
	}

	var gameIndex = {}
	for (var i = 0; i < rawGames.length; i++) {
		gameIndex[rawGames[i].game_id] = rawGames[i]
	}

	var gameIds = Object.keys(gameIndex).map(function(id) {
		return parseInt(id, 10)
	}).filter(Boolean)

	if (!gameIds.length) return { words: words }

	var categories = GameCategory.filter({
		arrayed: true,
		where: [
			['game_id', 'in', gameIds],
			['category_id', 'not in', [1042, 1044]]
		]
	})

	var categoryCounts = {}
	var categoryMeta = {}

	for (var j = 0; j < categories.length; j++) {
		var category = categories[j]

		if (!categoryCounts[category.category_id]) categoryCounts[category.category_id] = 0
		if (!categoryMeta[category.category_id]) categoryMeta[category.category_id] = 0

		if (filter.type === 'collection') {
			categoryCounts[category.category_id]++
		} else if (filter.type === 'ratings') {
			categoryCounts[category.category_id]++
			categoryMeta[category.category_id] += parseFloat(gameIndex[category.game_id].rating_value || 0)
		} else if (filter.type === 'plays') {
			categoryCounts[category.category_id] += parseInt(gameIndex[category.game_id].play_count || 0, 10)
		}
	}

	if (filter.type === 'ratings') {
		var ratingCategoryIds = Object.keys(categoryCounts)
		for (var k = 0; k < ratingCategoryIds.length; k++) {
			var ratingCategoryId = ratingCategoryIds[k]
			categoryCounts[ratingCategoryId] = categoryMeta[ratingCategoryId] / categoryCounts[ratingCategoryId]
		}
	}

	var sortedCategoryIds = Object.keys(categoryCounts).sort(function(a, b) {
		return categoryCounts[b] - categoryCounts[a]
	}).slice(0, 50)

	var categoryModels = Category.where([
		['category_id', 'in', sortedCategoryIds]
	]).associated()

	for (var l = 0; l < sortedCategoryIds.length; l++) {
		var categoryId = sortedCategoryIds[l]
		if (!categoryModels[categoryId]) continue

		words.push({
			text: categoryModels[categoryId].get_name(),
			value: categoryCounts[categoryId]
		})
	}

	return {
		words: words
	}
}

var TOOLS = {
	playgrid: function(owner, userIndex, filter) {
		return toolPlaygrid(owner, filter)
	},
	heatmap: function(owner, userIndex, filter) {
		return toolHeatmap(owner, userIndex, filter)
	},
	wordcloud: function(owner, userIndex, filter) {
		return toolWordcloud(userIndex, filter)
	}
}

export default function(params) {
	if (!params.slug && params.name) params = Object.assign({}, params, { slug: params.name })

	var owner = resolveOwner(params, F.OWNER_USER)
	if (!owner) {
		return Promise.reject({ error: 'Owner not found in offline database', offline: true })
	}

	var tool = TOOLS[params.tool]
	if (!tool) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	return Promise.resolve(tool(owner, [owner.get_id()], params.filter || {}))
}
